export const deleteMPCookies = (domain: string): void => {
  const allCookies = document.cookie.split(";");

  for (const rawCookie of allCookies) {
    const [name] = rawCookie.trim().split("=");
    if (name.startsWith("mp_")) {
      const expired = [
        `${name}=;`,
        `Expires=Thu, 01 Jan 1970 00:00:00 UTC;`,
        `Path=/;`,
        `Domain=${domain};`,
      ].join(" ");

      document.cookie = expired;
    }
  }
};
